/* Nokshi Arong — theme.js */
(function () {
  'use strict';

  // Mobile menu toggle
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-menu-toggle]');
    if (trigger) {
      const menu = document.querySelector('.header__nav');
      if (!menu) return;
      const isOpen = menu.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('menu-open', isOpen);
      return;
    }
    // Close when a nav link is tapped
    if (e.target.closest('.header__nav a')) {
      const menu = document.querySelector('.header__nav.is-open');
      if (menu) {
        menu.classList.remove('is-open');
        document.body.classList.remove('menu-open');
        const btn = document.querySelector('[data-menu-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
    }
  });

  // Accordion (native <details> handles it, but ensure only one open per group)
  document.querySelectorAll('.accordion[data-single] details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) {
        d.parentElement.querySelectorAll('details').forEach(function (o) {
          if (o !== d) o.open = false;
        });
      }
    });
  });

  // Quantity stepper (cart page only — the product page's own stepper is
  // handled entirely by product-main.liquid's inline script, since it also
  // needs to sync price/variant data on change. Both listeners firing on
  // the same buttons was doubling every click's increment.)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    if (btn.closest('[data-product-form]')) return;
    const wrapper = btn.closest('.qty');
    const input = wrapper && wrapper.querySelector('input');
    if (!input) return;
    const step = Number(btn.dataset.qtyStep);
    const current = Math.max(1, parseInt(input.value, 10) || 1);
    input.value = Math.max(1, current + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Reveal on scroll
  const revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  // Variant swatches
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    picker.addEventListener('click', function (e) {
      const swatch = e.target.closest('[data-variant-id]');
      if (!swatch) return;
      picker.querySelectorAll('[data-variant-id]').forEach(function (s) { s.classList.remove('is-active'); });
      swatch.classList.add('is-active');
      const form = picker.closest('form') || document.querySelector('[data-product-form]');
      if (form) {
        const idInput = form.querySelector('[name="id"]');
        if (idInput) idInput.value = swatch.dataset.variantId;
        const priceEl = document.querySelector('[data-product-price]');
        if (priceEl && swatch.dataset.variantPrice) priceEl.textContent = swatch.dataset.variantPrice;
      }
    });
  });
})();
